import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IResponse,
  IApplicationRole,
  IApplicationRoleCreate,
  IApplicationRoleDetails
} from '../models';

const baseUrl = '/api/application-roles';

export const getApplicationRoles = async (filters?: {
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IResponse<IApplicationRole[]>> => {
  try {
    const { data } = await axios.get(baseUrl, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getApplicationRoles failed');
    return Promise.reject(error.response.data);
  }
};

export const getApplicationRoleDetails = async (roleId: number): Promise<IApplicationRoleDetails> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${roleId}`);
    return data;
  } catch (error) {
    logError(error, 'getApplicationRoleDetails failed');
    return Promise.reject(error.response.data);
  }
};

export const createApplicationRole = async (post: IApplicationRoleCreate): Promise<any> => {
  try {
    const { data } = await axios.post(`${baseUrl}`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createApplicationRole failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const updateApplicationRole = async (
  roleId: string | number,
  payload: IApplicationRoleCreate
): Promise<any> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${roleId}`, payload);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: { roleId: roleId, roleDetails: payload }
      },
      'updateApplicationRole failed'
    );
    return Promise.reject(error.response.data);
  }
};

export const deleteApplicationRole = async (roleId: number | string): Promise<any> => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${roleId}`);
    return data;
  } catch (error) {
    logError(error, 'deleteApplicationRole failed');
    return Promise.reject(error?.response?.data);
  }
};